import type { Editor } from "@tiptap/core";
import { sanitizeLinkMarks } from "./getMarks";

export const sanitizeContent = ({ editor }: { editor: Editor }) => {
  if (editor.isEmpty) return;
  sanitizeLinkMarks({ editor });
};

export const sanitizeInputJson = (inputJson: any) => {
  try {
    if (!inputJson) return;
    const { content } = inputJson;
    const newContent = content.map((item: any) => {
      if (item.type == "paragraph") {
        const contents = item.content?.filter(
          (block: any) => !(block.type === "text" && block.text === ""),
        );
        return {
          ...item,
          content: contents,
        };
      }
      return item;
    });

    return {
      ...inputJson,
      content: newContent,
    };
  } catch (err) {
    console.error(`Error while sanitizing jsonContent`, err);
  }
};

export const editorHasNoMentionOrEntityOrMessage = (editor: Editor | null) => {
  if (!editor || editor.isEmpty) return true;

  const inputJson = editor.getJSON();
  if (!inputJson) return true;

  const { content } = inputJson || {};
  if (!content) return true;
  return !content.some((item: any) => {
    if (item.type === "paragraph") {
      return item.content?.some(
        (block: any) =>
          block.type === "mention" ||
          block.type === "entity" ||
          block.type === "message",
      );
    }
  });
};
